import React from "react";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { InputSwitch } from "primereact/inputswitch";
import MultiSearch from "../../../Components/SearchInputs/MultiSearch/MultiSearch";
import type { BannerSwap } from "../../../utils/@types";
import "../../YouTubeScorecard/Components/FilterBars/auditFilters.css";

const STATUSES = [
  { label: "Scheduled", value: "scheduled" },
  { label: "Running (Live)", value: "running" },
  { label: "Completed", value: "completed" },
  { label: "Partial failed", value: "partial_failed" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Failed", value: "failed" },
];

type Filters = {
  swapName: string;
  swapUID: string;
  createdBy: string;
  channelSearch: string;
  status: string[];
};

type Props = {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  unfilteredData: BannerSwap[];
  onSearch: () => void;
  onReset: () => void;
  onQueueNewSwap: () => void;
  mySwapsOnly: boolean;
  onMySwapsToggle: (value: boolean) => void;
};

const SwapQueueFilterBar: React.FC<Props> = ({
  filters,
  setFilters,
  unfilteredData,
  onSearch,
  onReset,
  onQueueNewSwap,
  mySwapsOnly,
  onMySwapsToggle,
}) => {
  const userOptions = Array.from(
    new Set(unfilteredData.map((item) => item.createdBy))
  )
    .filter(Boolean)
    .map((value) => ({ label: String(value), value }));

  return (
    <>
      <div className="grid-container">
        <div className="filter-item">
          <MultiSearch
            selectedItems={filters.swapUID ? [filters.swapUID] : []}
            value={(e) => {
              if (typeof e === "function") {
                const newArray = e([]);
                setFilters((prev) => ({
                  ...prev,
                  swapUID: newArray[0] || "",
                }));
              } else {
                setFilters((prev) => ({
                  ...prev,
                  swapUID: e[0] || "",
                }));
              }
            }}
            label="Swap UID"
            parseType="both"
          />
        </div>
        <div className="filter-item">
          <MultiSearch
            selectedItems={filters.swapName ? [filters.swapName] : []}
            value={(e) => {
              if (typeof e === "function") {
                const newArray = e([]);
                setFilters((prev) => ({
                  ...prev,
                  swapName: newArray[0] || "",
                }));
              } else {
                setFilters((prev) => ({
                  ...prev,
                  swapName: e[0] || "",
                }));
              }
            }}
            label="Task Name"
            parseType="both"
          />
        </div>
        <div className="filter-item">
          <span
            style={{ color: "grey", fontSize: "small", marginLeft: "0.4rem" }}
          >
            User
          </span>
          <MultiSelect
            value={filters.createdBy ? [filters.createdBy] : []}
            options={userOptions}
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                createdBy: e.value[0] || "",
              }))
            }
            maxSelectedLabels={1}
            optionLabel="label"
            style={{ width: "90%", borderRadius: "5px" }}
            filter
            showClear
            placeholder="Select User"
          />
        </div>
        <div className="filter-item">
          <MultiSearch
            selectedItems={
              filters.channelSearch ? [filters.channelSearch] : []
            }
            value={(e) => {
              if (typeof e === "function") {
                const newArray = e([]);
                setFilters((prev) => ({
                  ...prev,
                  channelSearch: newArray[0] || "",
                }));
              } else {
                setFilters((prev) => ({
                  ...prev,
                  channelSearch: e[0] || "",
                }));
              }
            }}
            label="Channel"
            parseType="both"
          />
        </div>
        <div className="filter-item">
          <span
            style={{ color: "grey", fontSize: "small", marginLeft: "0.4rem" }}
          >
            Status
          </span>
          <MultiSelect
            value={filters.status || []}
            options={STATUSES}
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                status: e.value || [],
              }))
            }
            optionLabel="label"
            style={{ width: "90%", borderRadius: "5px" }}
            filter
            showClear
            placeholder="Select Status"
            display="chip"
          />
        </div>
      </div>
      <div className="flex justify-between items-center mt-3 pt-1">
        <div className="flex items-center gap-2">
          <label htmlFor="mySwapsOnlyV2" className="text-sm text-gray-500">
            My Swaps Only
          </label>
          <InputSwitch
            id="mySwapsOnlyV2"
            checked={mySwapsOnly}
            onChange={(e) => onMySwapsToggle(e.value)}
          />
        </div>
        <div className="flex items-center gap-2">
          <Button
            label="Search"
            icon="pi pi-search"
            onClick={onSearch}
            severity="success"
            className="w-auto"
          />
          <Button
            label="Reset"
            icon="pi pi-replay"
            severity="danger"
            onClick={onReset}
            className="w-auto"
          />
          <Button
            label="Queue New Swap"
            icon="pi pi-plus"
            onClick={onQueueNewSwap}
            className="w-auto"
          />
        </div>
      </div>
    </>
  );
};

export default SwapQueueFilterBar;
